import * as React from 'react';
import {
  TourTooltipWrapperProps,
  TourTooltipWrapper,
} from '../tooltip/TourTooltipWrapper';
import {
  TourBackdropWrapperProps,
  TourBackdropWrapper,
} from '../backdrop/TourBackdropWrapper';
import {
  TourLoaderWrapperProps,
  TourLoaderWrapper,
} from '../loader/TourLoaderWrapper';
import { ArrowPosition } from '../../../types/assistant-actions';
import { TourHintWrapperProps, TourHintWrapper } from '../hint/TourHintWrapper';

export interface ReactDOMContainerState {
  tooltip: TourTooltipWrapperProps;
  backdrop: TourBackdropWrapperProps;
  hint: TourHintWrapperProps;
  loader: TourLoaderWrapperProps;
}

export class ReactDOMContainer extends React.Component<
  any,
  ReactDOMContainerState
> {
  state = {
    tooltip: {
      show: false,
      component: null,
      arrowComponent: null,
      content: '',
      title: '',
      activeActionIndex: null,
      arrowPosition: ArrowPosition.Left,
      successMessage: false,
      customProps: {},
    },
    backdrop: {
      show: false,
    },
    hint: {
      show: false,
    },
    loader: {
      show: false,
      component: null,
    },
  };

  render() {
    return (
      <>
        <TourTooltipWrapper {...this.state.tooltip} />
        <TourBackdropWrapper {...this.state.backdrop} />
        <TourHintWrapper {...this.state.hint} />
        <TourLoaderWrapper {...this.state.loader} />
      </>
    );
  }
}
